import { useRouter } from "next/router";
import { useEffect } from "react";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    // Redirect to monitors page
    router.replace("/dashboard/monitors");
  }, [router]);

  return null;
}
